import { useEffect, useMemo, useState } from "react";
import logo from "../../../common/assets/images/logo.png";
import { ReactComponent as TransactionOn } from "../../assets/icons/transactionOn.svg";
import { ReactComponent as TransactionOff } from "../../assets/icons/transactionOff.svg";
import { ReactComponent as SalesOn } from "../../assets/icons/salesOn.svg";
import { ReactComponent as SalesOff } from "../../assets/icons/salesOff.svg";
import { ReactComponent as OtherBranchOn } from "../../assets/icons/otherBranchOn.svg";
import { ReactComponent as OtherBranchOff } from "../../assets/icons/otherBranchOff.svg";
import { ReactComponent as MemberOn } from "../../assets/icons/memberOn.svg";
import { ReactComponent as MemberOff } from "../../assets/icons/memberOff.svg";
import { ReactComponent as SettingOn } from "../../assets/icons/settingOn.svg";
import { ReactComponent as SettingOff } from "../../assets/icons/settingOff.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";
import { useOpenedWindowsStore } from "../../store/useOpenedWindowsStore";

const NavBar = () => {
    const name = useAuthStore(state => state.m_name);

    const [activeTab, setActiveTab] = useState("transaction");
    const navigate = useNavigate();
    const location = useLocation();

    const navItems = useMemo(
        () => [
            { id: "transaction", label: "주문판매", OnIcon: TransactionOn, OffIcon: TransactionOff, path: "/console/transaction" },
            { id: "sales", label: "고객매출", OnIcon: SalesOn, OffIcon: SalesOff, path: "/console/sales" },
            { id: "otherBranch", label: "타지점정산", OnIcon: OtherBranchOn, OffIcon: OtherBranchOff, path: "/console/other-branch" },
            { id: "member", label: "회원목록", OnIcon: MemberOn, OffIcon: MemberOff, path: "/console/member" },
            { id: "settings", label: "관리", OnIcon: SettingOn, OffIcon: SettingOff, path: "/console/settings" },
        ],
        [],
    );

    const handleClick = (id: string, path: string) => {
        if (id === activeTab) return; // 현재 탭이면 무시

        const { openWindow } = useOpenedWindowsStore.getState();
        openWindow(id, path);
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate("/console");
    };

    useEffect(() => {
        const currentTab = navItems.find(item => location.pathname.startsWith(item.path))?.id || "transaction";
        setActiveTab(currentTab);

        const currentTitle = navItems.find(item => item.id === currentTab)?.label || "고려원예";
        document.title = `고려원예 - ${currentTitle}`;
    }, [location.pathname, navItems]);

    useEffect(() => {
        const currentTab = navItems.find(item => location.pathname.startsWith(item.path))?.id || "transaction";
        setActiveTab(currentTab);

        const currentTitle = navItems.find(item => item.id === currentTab)?.label || "고려원예";
        document.title = `고려원예 - ${currentTitle}`;
    }, [location.pathname, navItems]);

    return (
        <div className="h-dvh w-20 shrink-0 py-5 shadow-xl flex flex-col gap-7">
            <img src={logo} alt="logo" className="shrink-0 px-3" />
            {/*
            // 화면이 짧거나 확대하면 메뉴가 h-dvh 를 넘는다. 넘치면 여기서 세로로 스크롤한다.
            // min-h-0 이 없으면 flex 자식이 내용보다 작아지지 않아 스크롤이 안 생기고 밀어낸다.
            */}
            <div className="relative flex min-h-0 flex-1 flex-col">
                <div className="flex h-full flex-col gap-7 overflow-y-auto overflow-x-hidden">
                    {navItems.map(item => {
                        const isActive = activeTab === item.id;
                        const Icon = isActive ? item.OnIcon : item.OffIcon;

                        return (
                            <div
                                key={item.id}
                                className="flex shrink-0 items-center flex-col gap-1 cursor-pointer"
                                onClick={() => handleClick(item.id, item.path)}
                            >
                                <div
                                    className={`w-[52px] h-[52px] rounded-xl flex items-center justify-center ${
                                        isActive ? "bg-primary3" : "border border-grayicon"
                                    }`}
                                >
                                    <Icon />
                                </div>
                                {/*
                                // 웹폰트 없이 시스템 글꼴을 쓴다. 윈도우 맑은 고딕은 맥보다 글자가 넓어서
                                // 16px 이면 "타지점정산" 다섯 글자가 사이드바 폭(80px)을 넘어 양옆이 잘린다.
                                */}
                                <p
                                    className={`text-center text-sm whitespace-nowrap ${
                                        isActive ? "text-primary2 font-bold" : "text-gray2"
                                    } ${item.id === "otherBranch" ? "whitespace-nowrap" : ""}`}
                                >
                                    {item.label}
                                </p>
                            </div>
                        );
                    })}
                </div>
                {/*
                // 스크롤 경계 표시. 위아래 끝을 흐리게 해서 가려진 메뉴가 있다는 걸 알린다.
                // pointer-events-none 이라 클릭은 그대로 아래 메뉴로 간다.
                */}
                <div className="pointer-events-none absolute inset-x-0 top-0 h-4 bg-gradient-to-b from-white to-transparent" />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-4 bg-gradient-to-t from-white to-transparent" />
            </div>
            {/* absolute 로 띄우면 메뉴가 길어졌을 때 그 위에 겹친다. 흐름 안에 두고 아래로 민다 */}
            {/* 좌우 여백을 두면 윈도우 글꼴에서 "로그아웃"이 남은 폭(56px)을 넘어 두 줄이 된다 */}
            <div className="flex shrink-0 flex-col items-center mt-auto">
                <button className="text-gray1 mb-2.5 whitespace-nowrap text-sm">{name}</button>
                <button className="text-gray2 mb-3 underline whitespace-nowrap text-sm" onClick={handleLogout}>
                    로그아웃
                </button>
            </div>
        </div>
    );
};

export default NavBar;
